// extracted by mini-css-extract-plugin
module.exports = {"separator":"YourTokenSeccion_separator__kwTjm","yourTokenSeccionContainer":"YourTokenSeccion_yourTokenSeccionContainer__t0OG_","tokenGrid":"YourTokenSeccion_tokenGrid__DLZS2"};